if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"com_sankuai_powerbank_fe_mwp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}